import React, { forwardRef } from "react";
import styled from "styled-components";

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.text.primary};
`;

const StyledInput = styled.input`
  padding: 10px 12px;
  border: 1px solid ${props => props.theme.colors.border.light};
  border-radius: 6px;
  font-size: 14px;
  outline: none;

  &:focus {
    border-color: ${props => props.theme.colors.primary};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.primary}20;
  }
`;

const ErrorText = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.error};
`;

// ✅ Wrap with forwardRef so react-hook-form can attach refs
const Input = forwardRef(({ label, error, helpText, ...props }, ref) => {
  return (
    <InputWrapper>
      {label && <Label>{label}</Label>}
      <StyledInput ref={ref} {...props} />
      {helpText && <small>{helpText}</small>}
      {error && <ErrorText>{error}</ErrorText>}
    </InputWrapper>
  );
});

Input.displayName = "Input"; // 👈 avoids React DevTools warnings

export default Input;
